module.exports = __webpack_public_path__ + "img/NE.8191bec9.svg";